if (!customElements.get('bottom-navigation')) {
  class BottomNavigation extends HTMLElement {
    constructor() {
      super();
      this.chatToggleBtns = this.querySelectorAll('[data-chat-toggle]');
      this.lastScrollY = window.scrollY;
      this.scrollThreshold = 10;
      this.ticking = false;
      this.handleScroll = this.handleScroll.bind(this);
      this.handleChatStateChange = this.handleChatStateChange.bind(this);
    }

    connectedCallback() {

      window.addEventListener('scroll', this.handleScroll, { passive: true });

      this.chatToggleBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          document.dispatchEvent(new CustomEvent('nesta-chat:toggle'));
        });
      });

      this.menuToggleBtns = this.querySelectorAll('.bottom-navigation__item--menu');
      this.menuToggleBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
          if (window.innerWidth < 1024) {
            const menuTrigger = document.querySelector('.menu-trigger');
            if (menuTrigger) {
              e.preventDefault();
              menuTrigger.click();
            }
          }
        });
      });

      this.cartToggleBtns = this.querySelectorAll('.bottom-navigation__item--cart');
      this.cartToggleBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
          const cartTrigger = document.querySelector('button[name="cart-open"], #cart-open');
          if (cartTrigger) {
            e.preventDefault();
            cartTrigger.click();
          }
        });
      });

      document.addEventListener('nesta-chat:state-changed', this.handleChatStateChange);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
      document.removeEventListener('nesta-chat:state-changed', this.handleChatStateChange);
    }

    handleScroll() {
      // Disabled as per user request
    }

    updateVisibility() {
      // Disabled as per user request
    }

    handleChatStateChange(e) {
      if (e.detail && e.detail.isOpen) {
        // Bulletproof iOS scroll lock
        this.lastScrollY = window.scrollY;
        document.body.style.position = 'fixed';
        document.body.style.top = `-${this.lastScrollY}px`;
        document.body.style.width = '100%';
        document.body.style.left = '0';
        document.body.style.right = '0';
        
        document.body.classList.add('is-chat-open');
        document.documentElement.classList.add('is-chat-open');
        this.classList.remove('is-hidden');
      } else {
        // Unlock body and restore scroll
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        document.body.style.left = '';
        document.body.style.right = '';
        window.scrollTo(0, this.lastScrollY);
        
        document.body.classList.remove('is-chat-open');
        document.documentElement.classList.remove('is-chat-open');
      }
    }
  }

  customElements.define('bottom-navigation', BottomNavigation);
}
